import React from 'react';
import PropTypes from 'prop-types';
import './expandedUserRow.scss';

export class ExpandedUserRow extends React.Component {

    static contextTypes = {
        translator: PropTypes.func.isRequired,
        userDetail: PropTypes.object,
        isVisible: false
    };

    constructor (props) {
        super(props);
    }

    render () {
        const {
            emailAddress,
            faxNumber,
            phoneNumber,
            postalCode,
            sessionId,
            state,
            streetAddress1
        } = this.props.userDetail;

        return (
            <div className="expandedUserRowComponent ">

                <div className="contactInformation">
                    <div
                        className="title">{this.context.translator('userCenter.grid.expandedRow.contactInfoTitle')}</div>

                    <div className="row">
                        <div
                            className="rowLabel">{this.context.translator('userCenter.grid.expandedRow.address')}</div>
                        <div
                            className="rowValue">{streetAddress1} {streetAddress1 ? ',' : ''} {state} {postalCode}</div>
                    </div>

                    <div className="row">
                        <div
                            className="rowLabel">{this.context.translator('userCenter.grid.expandedRow.phone')}</div>
                        <div className="rowValue">{phoneNumber}</div>
                    </div>

                    <div className="row">
                        <div
                            className="rowLabel">{this.context.translator('userCenter.grid.expandedRow.fax')}</div>
                        <div className="rowValue">{faxNumber}</div>
                    </div>

                    <div className="row">
                        <div
                            className="rowLabel">{this.context.translator('userCenter.grid.expandedRow.email')}</div>
                        <div className="rowValue">{emailAddress}</div>
                    </div>

                </div>

                <div className="contactInformation">
                    <div
                        className="title">{this.context.translator('userCenter.grid.expandedRow.otherInformationTitle')}</div>
                    <div className="row">
                        <div className="rowLabel">
                            {this.context.translator('userCenter.grid.expandedRow.sessionId')}
                        </div>
                        <div className="rowValue">{sessionId}</div>
                    </div>
                </div>
            </div>);
    }
}
